/**
 * Admin Page - Admin operations
 * Features: Predictions table, manifest upload, predictions upload, and tag generation
 */

import React, { useState } from 'react';
import { Container, Typography, Box, Tabs, Tab, Button } from '@mui/material';
import { Build, ClearAll } from '@mui/icons-material';
import AppLayout from '../components/AppLayout';
import AdminPredictionsTable from '../components/admin/AdminPredictionsTable';
import UploadManifest from '../components/admin/UploadManifest';
import UploadPredictions from '../components/admin/UploadPredictions';
import UploadMathExpressions from '../components/admin/UploadMathExpressions';
// import TagGeneration from '../components/admin/TagGeneration';
import AppInfo from '../components/admin/AppInfo';
import Reports from '../components/admin/Reports';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `admin-tab-${index}`,
    'aria-controls': `admin-tabpanel-${index}`,
  };
}

export default function AdminPage() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleClearCache = () => {
    // Clear React Query cache and any other caches
    window.location.reload();
  };

  return (
    <AppLayout>
      <Container maxWidth="xl">
        <Box sx={{ py: 4 }}>
          {/* Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Build />
              <Typography variant="h4" gutterBottom sx={{ m: 0 }}>
                Admin Panel
              </Typography>
            </Box>
            <Button
              variant="outlined"
              startIcon={<ClearAll />}
              onClick={handleClearCache}
              sx={{ minWidth: 'auto' }}
            >
              Clear Cache
            </Button>
          </Box>

          {/* Tabs */}
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="admin tabs">
              <Tab label="Predictions Table" {...a11yProps(0)} />
              <Tab label="Upload Manifest" {...a11yProps(1)} />
              <Tab label="Upload Predictions" {...a11yProps(2)} />
              <Tab label="Upload Math Expressions" {...a11yProps(3)} />
              {/* <Tab label="Tag Generation" {...a11yProps(4)} /> */}
              <Tab label="Reports" {...a11yProps(4)} />
              <Tab label="App Info" {...a11yProps(5)} />
            </Tabs>
          </Box>

          {/* Tab Panels */}
          <TabPanel value={tabValue} index={0}>
            <AdminPredictionsTable />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <UploadManifest />
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            <UploadPredictions />
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            <UploadMathExpressions />
          </TabPanel>
          {/* <TabPanel value={tabValue} index={4}>
            <TagGeneration />
          </TabPanel> */}
          <TabPanel value={tabValue} index={4}>
            <Reports />
          </TabPanel>
          <TabPanel value={tabValue} index={5}>
            <AppInfo />
          </TabPanel>
        </Box>
      </Container>
    </AppLayout>
  );
}
